import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  Success,
  User
} from '@app/core/types/membership/membership.types';
import { VerificationChannel } from '@app/core/types/membership/membership.types';
import { environment } from 'environments/environment';
import { Observable, map } from 'rxjs';
import { X_HOHR_CAPTCHA_TOKEN } from '../constants/recaptcha.constant';

@Injectable({ providedIn: 'root' })
export class MembershipService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.url.api}/membership`;

  verifyPhoneMeStart(phoneNumber: string, captchaToken: string, channel: VerificationChannel): Observable<void> {
    return this.http.post<void>(
      `${this.url}/user/me/phonenumber/verification/start`,
      { phoneNumber, channel },
      { headers: { [X_HOHR_CAPTCHA_TOKEN]: captchaToken } }
    );
  }

  verifyPhoneMeCheck(phoneNumber: string, verificationCode: string): Observable<boolean> {
    return this.http
      .post(`${this.url}/user/me/phonenumber/verification/check`, {
        phoneNumber,
        verificationCode,
      })
      .pipe(map((response: Success) => response.success));
  }

  updatePhoneNumber(phoneNumber: string, phoneNumberVerificationCode: string, eTag: string): Observable<User> {
    return this.http.put<User>(`${this.url}/user/me/phonenumber`, {
      phoneNumber,
      phoneNumberVerificationCode,
      eTag,
    });
  }

  updateEmail(email: string, emailVerificationCode: string, eTag: string): Observable<User> {
    return this.http.put<User>(`${this.url}/user/me/email`, {
      email,
      emailVerificationCode,
      eTag,
    });
  }

  verifyEmailMeStart(email: string, captchaToken: string): Observable<void> {
    return this.http.post<void>(
      `${this.url}/user/me/email/verification/start`,
      { email },
    { headers: { [X_HOHR_CAPTCHA_TOKEN]: captchaToken } });
  }

  verifyEmailMeCheck(email: string, verificationCode: string): Observable<boolean> {
    return this.http
      .post(`${this.url}/user/me/email/verification/check`, {
        email,
        verificationCode,
      })
      .pipe(map((response: Success) => response.success));
  }

  resetPassword(): Observable<Success> {
    return this.http.post(`${this.url}/user/me/password/reset`, null).pipe(map((response: Success) => response));
  }

  getUserProfile(): Observable<User> {
    return this.http.get(`${this.url}/user/me`).pipe(map((response: User) => response));
  }

  getExternalId(): Observable<string> {
    return this.http
      .get<ExternalId>(`${this.url}/user/me/externalId`)
      .pipe(map((response: ExternalId) => response?.identifier));
  }
}

interface ExternalId {
  applicationName: string;
  identifier: string;
}
